export { SectionHero } from './StyledHero';
